/** Session flag set after admin login; read by `/admin/product/all` dashboard. */
export const ADMIN_AUTH_KEY = "jrAdminAuth";
